module.exports = __webpack_public_path__ + "img/product2.0b8dfb9b.jpg";